import React from 'react';
import {
  GridActionsDropdown,
  GridActionsDropdownSpecificProps,
} from 'Components/Display';
import {
  GridCellProps,
  GRID_COL_INDEX_ATTRIBUTE,
} from '@progress/kendo-react-grid';
import {
  ActionsDropdownConfig,
  EMPTY_GUID,
  GridRefreshableOptionalProps,
} from '@techsharegov/react-ui';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';

type ActionsEllipsisCellProps = Partial<GridCellProps> &
  GridActionsDropdownSpecificProps &
  GridRefreshableOptionalProps & {
    actionsConfig: ActionsDropdownConfig;
  };

export const ActionsEllipsisCell: React.FC<ActionsEllipsisCellProps> = ({
  actionsConfig,
  ...gridCellProps
}) => {
  const navigationAttributes = useTableKeyboardNavigation(
    gridCellProps.id ?? EMPTY_GUID
  );

  return (
    <td
      style={gridCellProps.style} // this applies styles that lock the column at a specific position
      className={gridCellProps.className} // this adds classes needed for locked columns
      colSpan={gridCellProps.colSpan}
      role={'gridcell'}
      aria-colindex={gridCellProps.ariaColumnIndex}
      aria-selected={gridCellProps.isSelected}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: gridCellProps.columnIndex }}
      {...navigationAttributes}
    >
      <GridActionsDropdown
        buttonWrapperClass="pl-regular flex-end full-width"
        {...gridCellProps}
        {...actionsConfig}
      />
    </td>
  );
};
